import { autobind } from 'core-decorators'
import { inject, observer } from 'mobx-react'
import * as React from 'react'
  import { History, match, withRouter } from 'react-router'
import { OfficeInstance } from '../../../models/Office'
import { LoadMoreButton } from '../../../shared/components/Button'
import { CenteredContent, Headlines, InnerContainer, PrimaryText } from '../../../shared/components/Elements'
import { Headline, SubHeadline } from '../../../shared/components/Headlines'
import { CalculatorStoreInstance } from '../../../stores/CalculatorStore'
import { OfficesList } from './result/OfficesList'

interface IProps {
  store?: CalculatorStoreInstance
  match?: match<{ code: string }>
  history?: History
}

interface IState {
  loading: boolean
  canLoadMore: boolean
}

@(withRouter as any)
@inject('store')
@observer
export class OfficesView extends React.Component<IProps, IState> {
  state: IState = {
    loading: true,
    canLoadMore: true
  }

  async componentDidMount () {
    const { store, match } = this.props
    await store!.fetchOffices(match.params.code)
    this.setState({ loading: false })
  }

  @autobind
  private async _loadMore () {
    this.setState({ loading: true })
    const { store, match } = this.props
    const offices = await store!.fetchOffices(match.params.code)
    this.setState({ loading: false, canLoadMore: offices.length >= 3 })
  }

  render () {
    const { loading, canLoadMore } = this.state
    const { offices } = this.props.store!

    return (<InnerContainer padded>
      <Headlines>
        <Headline centered>
          Unsere <PrimaryText>implacheck</PrimaryText> Implantologie-Spezialisten in Ihrer Nähe
        </Headline>
        <SubHeadline centered>Ein Experten-Netzwerk mit langjähriger Erfahrung</SubHeadline>
      </Headlines>

      <OfficesList loading={loading} offices={offices} trackingSource='calculator' />

      <CenteredContent>
        {canLoadMore && !loading && <LoadMoreButton onClick={this._loadMore}>Weitere Behandler</LoadMoreButton>}
      </CenteredContent>
    </InnerContainer>)
  }
}
